import { makeStyles } from '@mui/styles';

export const styles = makeStyles((theme) => ({
  defaultIcon: {
    height: 14,
    width: 14,
    cursor: 'pointer',
  },
}));
